import React from "react";
import AxiosServices from "./AxiosServices";

const Auth = new AxiosServices();

class InquiryServices 
{
  Create = async (data) => {
    return await Auth.post(`Inquiry/Create`, data);
  };
  GetInquiryList = async () => {
    return Auth.get(`Inquiry/InquiryList`);
  };
}

export default InquiryServices;